export default __webpack_public_path__ + "static/wall&desk-332aab0cdb6ccc2fe3865ae5d17d0a0b.png";